"use strict";

exports.__esModule = true;
exports.clearUndefined = exports.merge = void 0;

var merge = function merge(target) {
  for (var i = 0, j = arguments.length <= 1 ? 0 : arguments.length - 1; i < j; i++) {
    var source = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var prop in source) {
      if (Object.prototype.hasOwnProperty.call(source, prop)) {
        var value = source[prop];

        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

exports.merge = merge;

var clearUndefined = function clearUndefined(obj) {
  if (!obj || !typeof obj === 'object') return obj;
  var keys = Object.keys(obj);

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val = obj[key];

    if (typeof val === 'undefined') {
      delete obj[key];
    }
  }

  return obj;
};

exports.clearUndefined = clearUndefined;